/* eslint-disable no-debugger */
/* eslint-disable no-lonely-if */
/* eslint-disable no-sequences */
/* eslint-disable react/self-closing-comp */
/* eslint-disable import/named */
/* eslint-disable prefer-template */
/* eslint-disable one-var */
/* eslint-disable radix */
/* eslint-disable no-else-return */
/* eslint-disable no-shadow */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable vars-on-top */
/* eslint-disable eqeqeq */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-var */
/* eslint-disable camelcase */
/* eslint-disable arrow-body-style */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable object-shorthand */
/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable prefer-const */
/* eslint-disable dot-notation */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable no-empty */

import React, { useEffect, useState, useReducer } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import PropTypes, { object } from "prop-types";
import clsx from "clsx";
import moment from "moment";
// import {  } from "@material-ui/core";
import { Grid } from "@material-ui/core";
import { useHistory, useParams } from "react-router-dom";
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import Radio from "@mui/material/Radio";
import Button from '@mui/material/Button';
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import styles from "./AccessControlForm.module.css";
import {
  CustomFormGroup,
  ValidatingTextField,CustomDatePickerFinancial
} from "../FormComponents";
import {
  DATE_FORMAT,
  API_RESOURCE_URLS,
  DISPLAY_MESSAGES,
  MESSAGE_TYPE,
  RESOURCE_TYPE,
  USER_OPERATIONS,
  Regex,
} from "../../constants";
import { usePopupManager } from "../../providers/PopupManager/PopupManager";
import { withAllowedOperationsProvider } from "../../hocs";
import RequestViewAdditionalAccess from "./RequestViewAdditionalAccess";
import RequestViewBookingStatus from "./RequestViewBookingStatus";
import { fetchChassis, getInvoice,} from "../../redux/actions/productsActions";
// import TableSimple from "../../atomicComponents/TableSimple/TableSimple";
import TableSimple from "../../atomicComponents/TableSimple1/TableSimple";
import { setLogin } from '../../redux/features/auth/actions';
import Truckloading from "../CvLoader/Cvloader";
import { sanitizeCoCodeNumeric, sanitizeNumeric } from "../../utils/utils";
import apiService from "../../apis/apiService";

const initialState = {
  pers_no: "",
  BU: { label: "", value: "" },
  SUB_BU: "",
  PLATFORM: "",
  FAMILY: "",
  project_def: "",
  stmNo: "",
  chassisNo: null,
  toDate: null,
  fromDate: null,
  bodyBuilder: null,
  checkFlag: false,
  checkBox: false,
  checkTable: false,
  searchBox: "",
};
const reducer = (state, action) => {
  switch (action.type) {
    case "update":
      return {
        ...state,
        [action.field]: action.value,
      };
    case "reset":
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};

function RequestViewForm({baseUrl}) 
{
  const { requestType, activeId } = useParams();
  const [rowsData, setRowsData] = useState({
    loading: false,
    data: [],
    filteredData: [],
  });
  const [poData, setPOData] = useState({
    loading: false,
    data: [],
    filteredData: [],
    last: false,
    number: 0,
  });
  // const[Loadings,setLoadings]=useState(false);
  const [state, dispatch] = useReducer(reducer, initialState);
  const { showPopup } = usePopupManager();
  const history = useHistory();
  const dispatchNew= useDispatch();

  const [resetAllVisitedFields, setResetAllVisitedFields] = useState(false);
  const [highlightMandatoryFields, setHighlightMandatoryFields] = useState(false);
  const [viewDisplay, setViewDisplay] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [proDetails, setProDetails] = useState("");
  const [eDetails, setEDetails] = useState("");
  const [bodyBuilderOption, setBdybuilderOption] = useState([]);
  const [ExProjectDropdownList, setExProjectDropdownList] = useState([]);
  const [process, setProcess] = useState("");
  const[creationDate,setCreationDate]=useState(null)
  const auth = useSelector((state) => state.auth);
  let {
    userName,
    personNumber,
    companyCode,
    costCenter,
    userRole,
    sessionId,
    apiSendData
  } = auth;

  const [apiPayloadData, setAPIPaylodData] = useState(apiSendData);

  useEffect(() => {
    if (requestType) {
      const type = requestType.split("-").shift();
      if (type === "BS") {
        setProcess("Status");
      } else if (type === "PL") {
        setProcess("Project Linkage");
      }
    }
  }, [requestType, activeId]);
  
  useEffect(() => {
    // // console.log(userRole,'userRole')
    if (!userRole.includes("SA")) {
      // setDisableTicketNumber(true);
      setEDetails(personNumber)

    }
  }, [eDetails]);

   const [ProjectDropdownList, setProjectDropdownList] = useState([]);
  const [proDefDetails, setProDefDetails] = useState([]);
  const [changeFlag, setChangeFlag] = useState("");
  const [filterData, setFilterData] = useState([]);

  const request_type = useParams();
  const { parameter } = useParams();
  
  const [disable, setDisable] = useState(false);

  useEffect(() => {
    if (parameter === "APL") {
      setProcess("Project Linkage");
      setProDetails("Additional Project Linkage");
      setChangeFlag('NEW')
    }
    else if (parameter === "AA") {
      setProcess("Additional Access");
    }
    else if (parameter === "BS") {
      setProcess("Status");
    }
  }, [parameter]);

  useEffect(() => {
    if (request_type.requestType != undefined) {
      setDisable(true);
      if (
        request_type.requestType === "AA-NA-SUP" ||
        request_type.requestType === "AA-RTA-SUP" ||
        request_type.requestType === "AA-NA-DS" ||
        request_type.requestType === "AA-RTA-DS"
      ) {
        setProcess("Additional Access");
      }
    }
  }, [request_type, process]);

  // // console.log("Value of Process -> ", process)

  const [LinkageAccess, setLinkageAccess] = useState(false);
  const [additionalAccess, setAdditionalAccess] = useState(false);
  const [bookingStatus, setBookingStatus] = useState(false);

  const [empDetails, setEmpDetails] = useState([]);
  const [buDropdownList, setBuDropdownList] = useState([]);
  const [subBudropdownList, setSubBuDropdownList] = useState([]);
  const [platformdropdownList, setPlatformDropdownList] = useState([]);
  const [familydropdownList, setFamilyDropdownList] = useState([]);
  const [myState, setState] = React.useState({
    // poNo: "",
    pers_no: "",
    BU: { label: "", value: "" },
    SUB_BU: "",
    PLATFORM: "",
    FAMILY: "",
    project_def: "",
    user_remark: "",
    ticket_no: "",
    flag: "",
    stmNo: "",
    chassisNo: null,
    toDate: null,
    fromDate: null,
    hrs: "",
    spoc_ticket_no: "",
    spoc_remark: "",
    bodyBuilder: null,
    checkFlag: false,
    checkBox: false,
    checkTable: false,
    searchBox: "",
  });
  const [checkedItems, setCheckedItems] = useState({});
  const [existingData, setExistingData] = useState([]);
  const [modifiedData, setModifiedData] = useState([]);
  const [finalData, setFinalData] = useState([]);
  const [loadingTruck, setLoadingTruck] = React.useState(false);

  const getEmployeeDetails = async() => {
    setLoadingTruck(true);
    try {
      let apiFormatedData = {
        pers_no: sanitizeNumeric(eDetails),
        co_code: sanitizeCoCodeNumeric(companyCode)
      };
     const response = await apiService.GetAdditionalAccessRequestDetails(apiFormatedData, dispatchNew)    
    
     dispatchNew(setLogin({...auth, recentStatus: response.status}))
     if (response) {
      setLoadingTruck(false);
      if (response?.msg === 'Either User is non-bookable or belongs to non-bookable cost center' && !userRole.includes('SA')) {
        history.push('/home')
      }
      // console.log(responseJson.data["EmpdetailsList"].length, '===')
      if (response?.data["EmpdetailsList"].length === 0) {
        // console.log(responseJson.data["EmpdetailsList"].length, '===')

        showPopup({
          type: MESSAGE_TYPE.INFORMATION,
          contextText: MESSAGE_TYPE.INFORMATION,
          info: response?.msg,
        });
        setEDetails([]);
      } else {
        if(response?.msg === "Success" ){
          setLoadingTruck(false)
        // // console.log(responseJson,'responsedata')
        setEmpDetails(response?.data["EmpdetailsList"][0]);
        const Projectdropdown = [];
        response?.data?.bu_Dropdown.map((row) => {
          // Projectdropdown.push({label:row.project_def, value:row.project_def})
          Projectdropdown.push({
            label: `${row.project_def}-${row.project_desc}`,
            value: `${row.project_def}-${row.project_desc}`,
          });
        });

        setProjectDropdownList(Projectdropdown);
        const BUdropdown = [];
        response?.data?.bu_Dropdown.map((row) => {
          BUdropdown.push({ label: row.code_desc, value: row.code_desc });
        });
        setBuDropdownList(BUdropdown);
        const SUB_BUdropdown = [];
        response?.data?.bu_Dropdown.map((row) => {
          SUB_BUdropdown.push({ label: row.sub_bu, value: row.sub_bu });
        });
        setSubBuDropdownList(SUB_BUdropdown);
        const Platformdropdown = [];
        response?.bu_Dropdown.map((row) => {
          Platformdropdown.push({
            label: row.platform,
            value: row.platform,
          });
        });
        setPlatformDropdownList(Platformdropdown);
        const Familydropdown = [];
        response?.bu_Dropdown.map((row) => {
          Familydropdown.push({ label: row.family, value: row.family });
        });
        setFamilyDropdownList(Familydropdown);
      }  
       else if(response?.msg === "Fail"){
            setLoadingTruck(false)
        }      
    }
    }
    } catch (error) {
      setLoadingTruck(false)
    } finally{
      setLoadingTruck(false)
    }
  };

  const onChangeHandler = (event) => {
    const inputValue = event.target.value.trim();
    if (/^\d*$/.test(inputValue)) {
      setEDetails(inputValue);
    }
  };

  useEffect(() => {
    // // console.log("Ticket NUmber -> ", eDetails)
    if (eDetails.length == 6 &&  parameter=="APL") {
      getEmployeeDetails();
    } else {
      setEmpDetails([]);
      setProjectDropdownList([]);
      setExProjectDropdownList([]);
      setBuDropdownList([]);
      setSubBuDropdownList([]);
      setPlatformDropdownList([]);
      setFamilyDropdownList([]);
      setProDefDetails([]);
    }
  }, [eDetails,parameter]);

  useEffect(() => {
    const getRequestDetails = async() => {
      let apiFormatedData = {
        request_id: activeId,
      };
      // setLoadings(true)
      var apiFormatedDataJson = JSON.stringify(apiFormatedData);
      // // console.log("final", apiFormatedDataJson);
      let headerss = new Headers();
      headerss.append("Content-Type", "application/json");
      try {
        const response = await apiService.GetAdditionalAccessRequestDetails(apiFormatedData, dispatchNew)
        dispatchNew(setLogin({...auth, recentStatus: response.status}))   
          if (response["msg"] === "Success") {
            // setLoadings(false)
            let currdate=response?.data?.project_details[0].creation_date
            let formattedDate= moment(currdate,'DD-MM-YYYY').format('MM-DD-YYYY');
            setCreationDate(formattedDate)
            setState((prevData) => ({
              ...prevData,
              employee_details: response?.data?.employee_details[0],
              pl_hours: response?.data?.project_details[0]["pl_hours"],
              user_remark:
              response?.data?.project_details[0]["user_remark"],
              spoc_remark:
              response?.data?.project_details[0]["spoc_remark"],
              effective_date:
              response?.data?.project_details[0]["effective_date"],
              end_date: response?.data?.project_details[0]["end_date"],
              SPOCDetails:
              response?.data?.project_details[0]["spoc_ticket-no"],
            }));
            setEmpDetails(response?.data?.employee_details[0]);
            setProDefDetails(response?.data?.project_details[0]);
            if (response?.data?.project_details[0].request_type == "NEW") {
              setProDetails("Additional Project Linkage");
              setState((prevState) => ({
                ...prevState,
                checkFlag: true,
                checkTable: true,
              }));
            } else if (
              response?.data?.project_details[0].request_type == "EXTENDED"
            ) {
              setProDetails("Extend Existing Project Linkage");
              setState((prevState) => ({
                ...prevState,
                checkFlag: true,
                checkTable: true,
              }));
            }
          }

          if (response?.data != "User Logged In On another Screen") {
          const finalyList = [];
          const projectDefMap = new Map();
          response?.data?.project_details.forEach((row, index) => {
            const existingEntry = projectDefMap.get(row.project_def);

            if (existingEntry) {
              // If an entry with the same project_def already exists, update spoc_name
              existingEntry.spoc_name += `, ${row.spoc_name}`;
              existingEntry.spoc_ticket_no += `, ${row.spoc_ticket_no}`;
            } else {
              // If no entry with the same project_def exists, add a new entry to finalList
              projectDefMap.set(row.project_def, {
                id: index,
                ...row,
              });
            }
          });
          setExistingData([...projectDefMap.values()]);
          setState((prevState) => ({ ...prevState, ticket_no: "" }));
        }
        
      } catch (error) {
        showPopup({
          type: MESSAGE_TYPE.INFORMATION,
          contextText: MESSAGE_TYPE.INFORMATION,
          info: "Oops! Something went wrong. Please try again later",
        });
      }
    };
    if (activeId && requestType === "PL") {
      getRequestDetails();
    }
  }, [requestType, activeId]);

  const updateFinalData = () => {
    const filteredData = modifiedData.filter(
      (item, index) => checkedItems[index] === true
    );
    setFinalData(filteredData);
  };

  useEffect(() => {
    if (checkedItems.length != 0) {
      updateFinalData();
    }
  }, [checkedItems, modifiedData]);

  useEffect(() => {
  }, [finalData]);

  useEffect(() => {
    if (proDefDetails !== undefined && proDefDetails.length === 0) {
      setExistingData('');
    }
  }, [proDefDetails]);

  const handleSelectedProjectsChange = (newSelectedProjects) => {
    const newModifiedData = newSelectedProjects.map((item) => ({
      ...item,
      effective_date: item.effective_date || "",
      end_date: item.end_date || "",
      hrs: item.hrs || item.pl_hours || "",
    }));

    setModifiedData(newModifiedData);
  };

  useEffect(() => {
    if (existingData.length > 0) {
      handleSelectedProjectsChange(existingData);
    }
  }, [existingData]);
  useEffect(() => {
    if (eDetails.length === 6  && parameter=="APL") {
      handleExtendedDetails();
    }

  }, [eDetails, empDetails]);

  const handleExtendedDetails = async(e) => {
    // // console.log(e,"e vlue==========================")
    if (e === "Extend Existing Project Linkage") {
      setChangeFlag("EXTENDED");
      setEDetails("");
      setEmpDetails([]);
      setCheckedItems({})
      setState((prevData) => ({ ...prevData, user_remark: "" }));
    }
    setState((prevState) => ({
      ...prevState,
      checkFlag: true,
      checkTable: true,
    }));
    const commaSeparatedValues = ExProjectDropdownList.map((item) => item.value.split("-")[0]).join(",");
  
    let apiFormatedData = {
      bu: "",
      sub_bu: "",
      family: "",
      platform: "",
      project_def: commaSeparatedValues,
      bc_no: empDetails.bc_number,
      pers_num: sanitizeNumeric(eDetails),
      flag: changeFlag,
    };
    let headerss = new Headers();
    headerss.append("Content-Type", "application/json");
    try {
      const response = await apiService.GetAdditionalAccessRequestDetails(apiFormatedData, dispatchNew)
      dispatchNew(setLogin({...auth, recentStatus: response.status}))    
      if (response['msg'] === 'Success') {
        const finalList = [];
        const projectDefMap = new Map();
        response?.data.forEach((row, index) => {
          const existingEntry = projectDefMap.get(row.project_def);

          if (existingEntry) {
            existingEntry.spoc_name += `, ${row.spoc_name}`;
            existingEntry.spoc_no += `, ${row.spoc_no}`;
          } else {
            projectDefMap.set(row.project_def, {
              id: index,
              ...row,
            });
          }
        });
        setExistingData([...projectDefMap.values()]);
        const EXProjectdropdown = [];
        const uniqueProjects = new Set();
        response?.data.forEach((row) => {
          // Check if the project_def has been encountered before
          if (!uniqueProjects.has(row.project_def)) {
            // If it hasn't, add it to the dropdown and mark it as seen
            EXProjectdropdown.push({
              label: `${row.project_def}-${row.project_desc}`,
              value: `${row.project_def}`,
            });
            uniqueProjects.add(row.project_def);
          }
        });
        setExProjectDropdownList(EXProjectdropdown);
      } else {
        showPopup({
          type: MESSAGE_TYPE.INFORMATION,
          contextText: MESSAGE_TYPE.INFORMATION,
          info: "No Project Linkage Available",
        });
      }
    } catch (error) {
      
    }
  };

  const [backgroundColors, setBackgroundColors] = useState({
    processInfoBg: true,
    supplierInfoBg: false,
    poInfoBg: false,
    projectsInfoBg: false,
  });

  const { processInfoBg} = backgroundColors;

  const changeBackgroundColor = (field) =>
    setBackgroundColors((prev) => {
      const newBackgroundColors = {};
      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(prev)) {
        if (key === field) newBackgroundColors[key] = true;
        else newBackgroundColors[key] = false;
      }
      return newBackgroundColors;
  });

  const renderStatic = () => (
    <div
      className={styles.formGroup}
      style={{ backgroundColor: processInfoBg }}
      onClick={() => changeBackgroundColor("processInfoBg")}
    >
    </div>
  );

  const formatSpocDetails = (item) => {
    const spocDetailsArray = [];

    const ticketNos = (item.spoc_ticket_no || '').split(', ');
    const spocNames = (item.spoc_name || '').split(', ');

    for (let i = 0; i < ticketNos.length; i+=1) {
      const spocDetails = `${ticketNos[i]} - ${spocNames[i]}`;
      spocDetailsArray.push(spocDetails);
    }

    const uniqueValues = [...new Set(spocDetailsArray)];
    return uniqueValues.join(', ');
  };

  const formatSpocDetails1 = (item) => {
    const spocDetailsArray = [];

    const ticketNos = (item.spoc_no || '').split(', ');
    const spocNames = (item.spoc_name || '').split(', ');

    for (let i = 0; i < ticketNos.length; i+=1) {
      const spocDetails = `${ticketNos[i]} - ${spocNames[i]}`;
      spocDetailsArray.push(spocDetails);
    }

    return spocDetailsArray.join(', ');
  };

  const renderDetails = () => (
    <div
      className={styles.formGroup}
      style={{ backgroundColor: processInfoBg }}
      onClick={() => changeBackgroundColor("processInfoBg")}
    >
      <div className={styles.formGroup}>
        {myState.checkTable && existingData.length > 0 &&
          <Grid
            container
            spacing={1}
            className={styles.myGrid}
            style={{ marginTop: "10px" }}
            columns={12}
          >
            <Grid item md={12} lg={12} xs={12} sm={12}>
              {activeId &&
                <TableSimple
                  tableColumnData={existingData.map((item, index) => ({
                    projectNo: item.project_def,
                    projectDesc: item.project_desc,
                    startDate: (
                      <CustomDatePickerFinancial
                        inputProps={{
                          className: clsx(styles.select, styles.dateInput),
                        }}
                        autoOk
                        disabled
                        clearable
                        inputVariant="outlined"
                        value={modifiedData[index]?.effective_date || item?.effective_date}
                        emptyLabel="DD-MM-YYYY"
                        format="DD-MM-YYYY"
                        data-testid="date-picker-div-1"
                        style={{ width: "100%" }}
                      />
                    ),
                    endDate: (
                      <CustomDatePickerFinancial
                        inputProps={{
                          className: clsx(styles.select, styles.dateInput),
                        }}
                        autoOk
                        clearable
                        inputVariant="outlined"
                        disabled
                        value={modifiedData[index]?.end_date || item?.end_date}
                        emptyLabel="DD-MM-YYYY"
                        format="DD-MM-YYYY"
                        data-testid="date-picker-div-1"
                        style={{ width: "100%" }}
                      />
                    ),
                    SPOCDetails: item.request_pers === 'SA' ? 'SBP Team' : formatSpocDetails(item),
                    RequestId: activeId || "N/A",
                  }))}
                  tableHeaderLabel={[
                    "Project No_70",
                    "Project Description_150",
                    "Start Date_80",
                    "End Date_80",
                    "SPOC Details_100",
                    // "Hours_40",
                    "Request Id_80",
                  ]}
                  TableRowHederAling="start"
                  size="small"
                  headerColor="#E6F2FF"
                  className="custom-table"
                />
              }
              {changeFlag == "NEW" && proDefDetails.length > 0 &&
                <TableSimple
                  tableColumnData={existingData.map((item, index) => ({
                    projectNo: item.project_def,
                    projectDesc: item.project_desc,
                    startDate: (
                      <CustomDatePickerFinancial
                        inputProps={{className: clsx(styles.select, styles.dateInput),}}
                        autoOk
                        disabled
                        clearable
                        inputVariant="outlined"
                        value={moment(modifiedData[index]?.effective_date, 'DD-MM-YYYY') || moment(item?.effective_date, "DD-MM-YYYY")}
                        emptyLabel="DD-MM-YYYY"
                        format="DD-MM-YYYY"
                        data-testid="date-picker-div-1"
                        style={{ width: "100%" }}
                      />
                    ),
                    endDate: (
                      <CustomDatePickerFinancial
                        inputProps={{className: clsx(styles.select, styles.dateInput),}}
                        autoOk
                        clearable
                        inputVariant="outlined"
                        disabled
                        value={moment(modifiedData[index]?.end_date, "DD-MM-YYYY") || moment(item?.end_date, "DD-MM-YYYY")}
                        emptyLabel="DD-MM-YYYY"
                        format="DD-MM-YYYY"
                        data-testid="date-picker-div-1"
                        style={{ width: "100%" }}
                      />
                    ),
                    SPOCDetails: item.request_pers === 'SA' ? 'SBP Team' : formatSpocDetails(item),
                  }))}
                  tableHeaderLabel={[
                    // "Select_hide",
                    "Project No_70",
                    "Project Description_170",
                    "Start Date_80",
                    "End Date_80",
                    "SPOC Details_100",
                    // "Request Id",
                    // "Hours_40",
                  ]}
                  TableRowHederAling="start"
                  size="small"
                  headerColor="#E6F2FF"
                  className="custom-table"
                />
              }

              {changeFlag == "EXTENDED" && existingData.length !== 0 && proDefDetails.length !== 0 &&
               <TableSimple
                  tableColumnData={filterData.map((item, index) => ({
                    projectNo: item.project_def,
                    projectDesc: item.project_desc,
                    startDate: (
                      <CustomDatePickerFinancial
                        inputProps={{className: clsx(styles.select, styles.dateInput),}}
                        disabled
                        autoOk
                        clearable
                        inputVariant="outlined"
                        value={moment(filterData[index]?.effective_date) || item?.effective_date}
                        emptyLabel="DD-MM-YYYY"
                        format="DD-MM-YYYY"
                        data-testid="date-picker-div-1"
                        style={{ width: "100%" }}
                      />
                    ),
                    endDate: (
                      <CustomDatePickerFinancial
                        inputProps={{className: clsx(styles.select, styles.dateInput),}}
                        disabled
                        autoOk
                        clearable
                        inputVariant="outlined"
                        value={moment(filterData[index]?.end_date) || item?.end_date}
                        emptyLabel="DD-MM-YYYY"
                        format="DD-MM-YYYY"
                        data-testid="date-picker-div-1"
                        style={{ width: "100%" }}
                      />
                    ),
                    SPOCDetails: item.request_pers === 'SA' ? 'SBP Team' : formatSpocDetails1(item),
                  }))}
                  tableHeaderLabel={[
                    // "Select_30",
                    "Project No_70",
                    "Project Description_170",
                    "Start Date_80",
                    "End Date_80",
                    "SPOC Details_100",
                    // "Request Id",
                    // "Hours_40",
                  ]}
                  TableRowHederAling="start"
                  size="small"
                  headerColor="#E6F2FF"
                  className="custom-table"
                />
              }
            </Grid>
          </Grid>}
      </div>

    </div>
  );

  const renderOther = () => (
    <div
      className={styles.formGroup}
      onClick={() => changeBackgroundColor("processInfoBg")}
    >
      <Grid
        container
        spacing={1}
        className={styles.myGrid}
        style={{ marginTop: "10px" }}
        columns={12}
      >
        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>Ticket Number</label>
            </div>
            <div className={styles.formDiv}>
              <ValidatingTextField
                variant="outlined"
                size="small"
                //      value={myState.materialNo}
                onChange={(e) => setEDetails(e.target.value)}
                name="Ticket Number"
                inputProps={{
                  "data-testid": "remark-input",
                }}
                style={{ width: "70%" }}
              />
            </div>
          </div>
          {myState.handoverDateFlag && (
            // <div style={{ "display": "block" }}  className={styles.invalidfeedback}>Reported date should not be less than invoice date</div>
            <div style={{ marginLeft: "35px" }} className={styles.error}>
              Inserted On is mandatory field
            </div>
          )}
        </Grid>

        <Grid item md={4} lg={4}>
          {myState.handoverDateFlag && (
            // <div style={{ "display": "block" }}  className={styles.invalidfeedback}>Reported date should not be less than invoice date</div>
            <div style={{ marginLeft: "35px" }} className={styles.error}>
              Inserted On is mandatory field
            </div>
          )}
        </Grid>
      </Grid>
      {eDetails.length >= 6 ? renderOther1() : renderOther}
    </div>
  );

  const renderOther1 = () => (
    <div
      className={styles.formGroup}
    >
      <Grid
        container
        spacing={0}
        className={styles.myGrid}
        columns={12}
      >
        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={styles.formDiv}>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                markIfUnselected={highlightMandatoryFields}
                resetAllVisitedFields={resetAllVisitedFields}
                style={{
                  marginLeft: "21px",
                  marginRight: "11px",
                  alignItems: "center",
                  float: "center",
                }}
                value={proDetails}
                defaultValue=""
                className={styles.radiobtn}
              >

                <FormControlLabel
                  value="Additional Project Linkage"
                  name="status"
                  control={<Radio size="small" disabled="true" />}
                  label="Additional Project Linkage"
                  className={styles.radiobtn}
                />
              </RadioGroup>
            </div>
          </div>
        </Grid>
        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={styles.formDiv}>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                markIfUnselected={highlightMandatoryFields}
                resetAllVisitedFields={resetAllVisitedFields}
                style={{
                  marginLeft: "21px",
                  marginRight: "11px",
                  alignItems: "center",
                  float: "center",
                }}
                options={bodyBuilderOption}
                value={proDetails}
                name="bodyBuilder"
              >
                <FormControlLabel
                  value="Extend Existing Project Linkage"
                  name="status"
                  control={<Radio size="small" disabled="true" />}
                  label="Extend Existing Project Linkage"
                  className={styles.radiobtn}
                />
              </RadioGroup>
            </div>
          </div>
        </Grid>
      </Grid>
      {loadingTruck ? (
          <div style={{textAlign:"center",display:"flex",justifyContent:"center",marginTop:"40px"}}>
               <Truckloading />
            </div>): <div className={styles.formGroup}>
        {proDetails && (
          <Grid
            container
            spacing={1}
            style={{ marginTop: "10px" }}
            columns={12}
          >
            <Grid item md={2} lg={2} xs={2} sm={2}>
              <div className={styles.rowDiv}>
                <div className={clsx(styles.lableDiv2)}>
                  <label>Employee Details:</label>
                </div>
              </div>
            </Grid>
            <Grid item md={10} lg={10} xs={10} sm={10}>
              <div className={styles.formDiv}>
                <TableSimple
                  // tableColumnData={empDetails}
                  tableColumnData={[
                    {
                      ticket: activeId ? (
                        <div>{empDetails.employee_ticket_no}</div>
                      ) : (
                        <ValidatingTextField
                          variant="outlined"
                          size="small"
                          isDisabled="true"
                          // value={empDetails.employee_ticket_no}
                          value={eDetails}
                          name="Ticket Number"
                          inputProps={{
                            "data-testid": "remark-input",
                          }}
                          style={{ width: "100%" }}
                        />
                      ),
                      empl_name: empDetails?.empl_name || "",
                      bcNo: empDetails?.bc_number || "",
                      bc_name: empDetails?.bc_name || "",
                      workArea: empDetails?.workarea || "",
                    },
                  ]}
                  tableHeaderLabel={[
                    "Ticket No_60",
                    "Employee Name_140",
                    "BC No_60",
                    "BC Description_150",
                    "Work Area_230",
                  ]}
                  TableRowHederAling="start"
                  size="small"
                  // headerColor="#2C73D2"
                  headerColor="#E6F2FF"
                  className="custom-table"
                />
              </div>
            </Grid>
          </Grid>
        )}
      </div>
        }
      
    </div>
  );

  const renderUserRemark = () => (
    <div
      className={styles.formGroup}
      style={{ backgroundColor: processInfoBg }}
      onClick={() => changeBackgroundColor("processInfoBg")}
    >
      <div className={styles.formGroup}>
        <Grid
          container
          spacing={1}
          style={{
            marginTop: "10px",
          }}

          columns={12}
        >
          <Grid item md={2} lg={2} xs={2} sm={2}>
            <div className={clsx(styles.lableDiv2)}>
              <label>User Remark:</label>
            </div>
          </Grid>
          <Grid item md={10} lg={10} xs={10} sm={10}>
            <div className={styles.formDiv}>
              <ValidatingTextField
                isDisabled="true"
                variant="outlined"
                size="small"
                value={myState.user_remark}
                name="user_remark"
                inputProps={{
                  "data-testid": "remark-input",
                }}
                style={{ width: "100%" }}
              />
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );

  const renderSPOCRemark = () => (
    <div className={styles.formGroup}>
      <Grid
        container
        spacing={1}
        style={{ marginTop: "10px"}}
        columns={12}
      >
        {activeId && (
          <>
            <Grid item md={2} lg={2} xs={2} sm={2}>
              <div className={clsx(styles.lableDiv2)}>
                <label>SPOC Remark:</label>
              </div>
            </Grid>
            <Grid item md={10} lg={10} sm={10} xs={10}>
              <div className={styles.rowDiv}>
                <div className={styles.formDiv}>
                  <ValidatingTextField
                    isDisabled="true"
                    variant="outlined"
                    size="small"
                    value={myState.spoc_remark}
                    name="spoc_remark12"
                    inputProps={{"data-testid": "remark-input",}}
                    style={{ width: "100%" }}
                  />
                </div>
              </div>
            </Grid>
          </>
        )}
      </Grid>
    </div>
  );

  useEffect(() => {
    // // console.log("status", process)
    if (process === "Status") {
      setViewDisplay(false);
      setIsDelete(true);
      setLinkageAccess(false);
      setAdditionalAccess(false);
      setBookingStatus(true);
      setState((prevState) => ({ ...prevState, tableFlag: true }));
      setProDefDetails();
    }
  }, [process]);

  useEffect(() => {
    if (resetAllVisitedFields);
  }, [resetAllVisitedFields]);

  const RedirectToDashboard = () => {
    const reqtype = requestType.split("-").shift();
      if (reqtype == "PL" ) {
        dispatch(setLogin({ ...auth, apiSendData: apiPayloadData}));
        history.push("/linkage-dashboard");
      }
      else if(reqtype == "BS" || reqtype == "AA") {
        dispatch(setLogin({ ...auth, apiSendData: apiPayloadData}));
        history.push("/requestor-dashboard")
      }
  } 

  return (
    <>
      <div
        className={clsx(
          styles.scrollContainer,
          styles.scrollBar,
          styles.formContainer
        )}
      >

        {process === "" ? null : process === "Project Linkage" ? (
          <>
         <Grid container spacing={0}>
            <Grid item md={1} lg={1} xs={1} sm={1} style={{marginRight: '-35px'}}> 
              <ArrowCircleLeftIcon 
                  style={{
                    fontSize:'40px', 
                    color: "#608FC9", 
                    margin: '-4px 0px 1px 10px',
                    cursor: 'pointer'
                  }} 
                  onClick={() => RedirectToDashboard()}
                />
            </Grid>
            <Grid item md={11} lg={11} xs={9} sm={9}> 
            <CustomFormGroup
              header="Additional Project Linkage"
              body={renderStatic()}
            />
            </Grid>
         </Grid>
            {renderOther1()}
            {empDetails?.empl_name &&
              <>
                {renderDetails()}
                {renderUserRemark()}
              </>
            }
            {myState.checkTable && empDetails?.empl_name &&
              <>
                {renderSPOCRemark()}
              </>
            }
          </>

        ) : null}

        {process === "" ? null : process === "Additional Access" ? (
            <RequestViewAdditionalAccess />
        ) : null}

        {process === "" ? null : process === "Status" ? (
          <>
            <RequestViewBookingStatus />
          </>
        ) : null}

      </div>
          
    </>
  );
}

RequestViewForm.propTypes = {
  redirectToProcessPage: PropTypes.func,
};

const mapStateToProps = (state) => ({
  product: state.product,
  counter: state.counter.value,
  baseUrl: state.counter.baseUrl,
  auth: state.auth,
});
const mapDispatchToProps = (dispatch) => ({
  fetchChassis: (chassisParam) => dispatch(fetchChassis(chassisParam)),
  getInvoice: (chassisParam) => dispatch(getInvoice(chassisParam)),
});
RequestViewForm.propTypes = {
  counter: PropTypes.number,
  baseUrl: PropTypes.string,
  product: PropTypes.object,
  auth: PropTypes.object,
};
const App = connect(mapStateToProps, mapDispatchToProps)(RequestViewForm);

export default withAllowedOperationsProvider(App, RESOURCE_TYPE.PPAP);